<template>
  <td v-if="isShowToggle" class="hrmThemeTableTd">
    <VueToggle name="VueToggle" :toggled="getToggleState()" @toggle="updateStatus(rowData)" />
  </td>
  <td v-else class="hrmThemeTableTd">
    {{ rowData.status_val }}
  </td>
</template>
<script setup lang="ts">
import { ref, inject, onMounted } from 'vue'
import VueToggle from 'vue-toggle-component'
import { useAppStore } from '@/store/index'

// props
interface Props {
  rowData: any
  statusPermission?: string | boolean
  statusUpdateApi?: string
  pageName?: string
  statusUpdateType?: string
}

const props = withDefaults(defineProps<Props>(), {
  statusUpdateType: 'updateAll'
})

const emit = defineEmits(['refreshTable'])

// injections
const projectUUid = inject<any>('projectUUid')

// store
const appStore = useAppStore()

const isShowToggle = ref(false)
const errors = ref<any>(null)

function updateStatus(rowData: any) {
  let form: any = {}
  let method: any = 'post'

  if (props.pageName == 'Candidate') {
    form.status = rowData.status == 1 ? 0 : 1
  } else if (props.pageName == 'LegalEntity') {
    form.status = rowData.status_val == 'Active' ? false : true
  } else if (props.pageName == 'Template') {
    form.status = rowData.status_val == 'Active' ? false : true
    method = 'put'
  } else if (props.pageName == 'tenants') {
    form.status = rowData.status == true ? false : true
    method = 'put'
  } else if (props.pageName == 'modulesTenants') {
    form.active = rowData.active == 'Active' ? false : true
    method = 'put'
  } else if (props.pageName == 'leadsTenants') {
    form.status = rowData.status == 1 ? false : true
  } else if (props.pageName == 'UserNotification') {
    form.status = rowData.user_status == 0 ? true : false
  } else {
    form.status = rowData.status == 1 ? false : true
  }

  let appRoute: any = null
  if (props.pageName == 'projectDateWise') {
    form.status = rowData.status_val == 'Active' ? false : true
    appRoute = route(props.statusUpdateApi, { uuid: projectUUid, id: rowData.id })
  } else {
    appRoute = route(props.statusUpdateApi, { id: rowData.id })
  }

  axios.request({
    url: appRoute,
    method,
    data: form
  })
    .then((res: any) => {
      const notification = {
        heading: trans('lang.labels.success'),
        subHeading: res.data.message,
        type: 'success'
      }
      appStore.setNotification(notification)
      emit('refreshTable')
    })
    .catch((error: any) => {
      errors.value = error?.response?.data?.errors
    })
}

function getToggleState() {
  let isToggle: any = null

  if (props.pageName == 'Candidate') {
    isToggle = props.rowData.status == 1 ? true : false
  } else if (props.pageName == 'LegalEntity') {
    isToggle = props.rowData.status_val == 'Active' ? true : false
  } else if (props.pageName == 'tenants') {
    isToggle = props.rowData.status == true ? true : false
  } else if (props.pageName == 'modulesTenants') {
    isToggle = props.rowData.active == 'Active' ? true : false
  } else if (props.pageName == 'UserNotification') {
    isToggle = props.rowData.user_status == 0 ? false : true
  } else if (props.pageName == 'projectDateWise') {
    isToggle = props.rowData.status_val == 'Active' ? true : false
  } else {
    isToggle = props.rowData.status == 1 ? true : false
  }

  return isToggle
}

onMounted(() => {
  if (props.statusUpdateType == 'updateAll') {
    if (typeof props.statusPermission == 'boolean') {
      isShowToggle.value = props.statusPermission
    } else {
      isShowToggle.value = checkPermission(props.statusPermission)
    }
  } else if (props.statusUpdateType == 'employeeReportPage') {
    const defaultReportId = (window as any).APP.default_report_template
    if (defaultReportId == props.rowData.id) {
      isShowToggle.value = false
    } else {
      if (typeof props.statusPermission == 'boolean') {
        isShowToggle.value = props.statusPermission
      } else {
        isShowToggle.value = checkPermission(props.statusPermission)
      }
    }
  } else {
    isShowToggle.value = props.statusPermission as boolean
  }
})
</script>

<style scoped></style>